import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TInputs = {
  lastActiveFrom: string;
  lastActiveTo: string;
};

const defaultValues: TInputs = {
  lastActiveFrom: '',
  lastActiveTo: '',
};

export const LastActiveFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  useEffect(() => {
    if (params.lastActiveFrom || params.lastActiveTo) setIsActive.on();
    else setIsActive.off();
  }, [params.lastActiveFrom, params.lastActiveTo]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  const updateValues = () => {
    setValue('lastActiveFrom', (params?.lastActiveFrom as string) ?? '');
    setValue('lastActiveTo', (params?.lastActiveTo as string) ?? '');
  };

  useEffect(() => {
    updateValues();
  }, [params.lastActiveFrom, params.lastActiveTo]);

  const onSubmit = (data: TInputs) => {
    params.lastActiveFrom = data.lastActiveFrom;
    params.lastActiveTo = data.lastActiveTo;
    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => (Object.keys(formState.dirtyFields).length ? false : true);

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='lastActiveFrom'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Last Active From</FormLabel>
                <Input type='date' onChange={onChange} size='sm' onBlur={onBlur} value={value} name={name} />
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name='lastActiveTo'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Last Active To</FormLabel>
                <Input type='date' onChange={onChange} size='sm' onBlur={onBlur} value={value} name={name} />
              </FormControl>
            )}
          />
          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
